import { defineComponent as _defineComponent } from 'vue'
import { ref, computed } from 'vue'
import { useRoute, useRouter } from 'vue-router/composables'

import Card from '../../../../components/ui/Card.vue'
import ContentBody from '../../../../components/ui/ContentBody.vue'
import ContentHeader from '../../../../components/ui/ContentHeader.vue'
import Breadcrumb from '../../../../components/ui/breadcrumb/Breadcrumb.vue'
import Tag from '../../../../components/ui/tag/Tag.vue'
import { RouterLink } from 'vue-router'


export default /*#__PURE__*/_defineComponent({
  __name: 'FireRiskSettings.layout',
  setup(__props) {

const route = useRoute()

const { getCrumbs, children } = useLayoutCrud()

const step = ref(getCrumbs().length - 1)

function useLayoutCrud() {
	const { currentRoute } = useRouter()
	const { name } = currentRoute

	function getCrumbs() {
		const pathArray = (useRouter().currentRoute.meta!.breadcrumb as string)
			.split('/')
			.filter((crumb) => crumb != '')

		return pathArray.map((crumb, index) => {
			return {
				name: crumb,
				step: index,
			}
		})
	}

	const children = computed(() => {
		return [
			{
				name: 'configurações de alerta',
				path: '/fire-risk/alert-settings',
			},
			{ name: 'usuários notificados', path: '/fire-risk/notified-users' },
		]
	})

	return { getCrumbs, children, name }
}

return { __sfc: true,route, getCrumbs, children, step, useLayoutCrud, Card, ContentBody, ContentHeader, Breadcrumb, Tag, RouterLink }
}

})